export default __webpack_public_path__ + "static/media/TennisDick.bf46bb49.PNG";